jQuery(function ($) {
  $('.services').each(function () {
    const $section = $(this);
    const $tabs = $section.find('.service-tab');
    const $images = $section.find('.service-image-container');

    $tabs.on('mouseenter', function () {
      const hash = this.hash; // e.g., #branding
      const slug = hash.substring(1); // remove #
      const className = `.image-${slug}`;

      // Remove active from all in this section
      $images.removeClass('active');

      // Add active to all matching images within this section
      $section.find(className).addClass('active');
    });

    // Clear on mouse leave from tab wrapper
    $section.find('.services-tabs').on('mouseleave', function () {
      $images.removeClass('active');
    });
  });
});
